export function base64ToFile(base64Image: string, fileName: string) {
  const array = base64Image.split(',');
  const mime = array[0]?.match(/:(.*?);/)?.[1];
  const decodedString = atob(array[1]);
  let stringLength = decodedString.length;
  const u8array = new Uint8Array(stringLength);

  while (stringLength--) {
    u8array[stringLength] = decodedString.charCodeAt(stringLength);
  }

  return new File([u8array], fileName, { type: mime });
}

const FILE_SIZE_UNITS = ['byte', 'kilobyte', 'megabyte', 'gigabyte', 'terabyte', 'petabyte'];

// A file size in the locale's own units and decimal mark, such as "470,8 ko" in French and "470.8 kB" in English.
export function formatFileSize(bytes: number, locale: string) {
  const exponent = bytes > 0 ? Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), FILE_SIZE_UNITS.length - 1) : 0;
  return new Intl.NumberFormat(locale, {
    style: 'unit',
    unit: FILE_SIZE_UNITS[exponent],
    unitDisplay: 'short',
    maximumFractionDigits: 1,
  }).format(bytes / 1024 ** exponent);
}

// A size limit as the whole number of megabytes a message quotes, such as "25" for 25 MB.
export function bytesToMegabytes(bytes: number) {
  return Math.round(bytes / (1024 * 1024));
}

export function downloadFile(file: Blob | MediaSource) {
  const url = URL.createObjectURL(file);

  const link = document.createElement('a');
  link.href = url;

  if (file instanceof Blob) {
    link.download = file.name;
  } else {
    link.download = 'mediaSourceFile';
  }

  link.click();

  URL.revokeObjectURL(url);
}
